import { inject, bindable } from 'aurelia-framework';
import { FavoriteService } from 'resources/elements/favorite/service';

@inject(FavoriteService)
export class Favorite {
    @bindable path;
    @bindable name;

    constructor(favoriteService) {
        this.favoriteService = favoriteService;
    }

    attached() {
        this.exists = this.favoriteService.favorites.some(x => x.path === this.path);
    }

    async toggleFavorite() {
        if (this.exists) {
            await this.favoriteService.removeFavorite(this.path);
            this.exists = false;
        } else {
            await this.favoriteService.addFavorite(this.name, this.path);
            this.exists = true;
        }
    }
}